import React from "react";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";
import { object } from "prop-types";

import FacebookIcon from "../FooterIcons/FacebookIcon";
import TwitterIcon from "../FooterIcons/TwitterIcon";
import Instagram from "../../../atoms/icons/Instagram";
import YoutubeIcon from "../FooterIcons/YoutubeIcon";

import "./bondhushavaFooter.m.css";

const BondhushavaFooter = ({ customSocialLinks, socialLinks }) => {
  const socialShareLinks = customSocialLinks.bondhushava || socialLinks;

  return (
    <div styleName="bondhushava-footer">
      <div styleName="address">
        <span className="line-1">বন্ধুসভা কক্ষ, ঢাকা ট্রেড সেন্টার (৩য় তলা), ৯৯ কাজী </span>
        <span className="line-2">নজরুল ইসলাম অ্যাভিনিউ, কারওয়ান বাজার </span>
        <span className="line-3">ঢাকা-১২১৫ </span>
        <span className="line-4">ফোন: ৮১১০০৮১ , ৮১১৫৩০৭-১০, (১৫২০, ১৫২১) </span>
        <span className="line-5">মোবাইল: ০১৯৫৫৫৫২০৮৮</span>
        <span className="line-6">
          ইমেইল: <a href="mailto:bondhushava@prothomalo.com">bondhushava@prothomalo.com</a>
        </span>
      </div>
      <div styleName="social-links">
        {socialShareLinks["facebook-url"] && (
          <Link href={socialShareLinks["facebook-url"]} target="_blank" rel="noopener noreferrer">
            <FacebookIcon color="#26afe8" />
          </Link>
        )}
        {socialShareLinks["twitter-url"] && (
          <Link href={socialShareLinks["twitter-url"]} target="_blank" rel="noopener noreferrer">
            <TwitterIcon color="#26afe8" />
          </Link>
        )}
        {socialShareLinks["instagram-url"] && (
          <Link href={socialShareLinks["instagram-url"]} target="_blank" rel="noopener noreferrer">
            <Instagram color="#26afe8" />
          </Link>
        )}
        {socialShareLinks["youtube-url"] && (
          <Link
            href={socialShareLinks["youtube-url"]}
            className="youtube-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YoutubeIcon color="#26afe8" />
          </Link>
        )}
      </div>
      <span styleName="copyright">© স্বত্ব বন্ধুসভা ১৯৯৮ – ২০১৯</span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
});

BondhushavaFooter.propTypes = {
  socialLinks: object,
  customSocialLinks: object,
};

export default connect(mapStateToProps)(BondhushavaFooter);
